/** Decorative map-pin glyph — parent control owns `aria-label` / accessible name (G6). */
export function MapPinIcon({
  className = 'h-5 w-5',
}: {
  readonly className?: string;
}): JSX.Element {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
      fill="none"
    >
      <path
        d="M12 21.5s-6.5-5.35-6.5-10.25a6.5 6.5 0 1 1 13 0C18.5 16.15 12 21.5 12 21.5Z"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinejoin="round"
      />
      <circle
        cx="12"
        cy="11.25"
        r="2.25"
        stroke="currentColor"
        strokeWidth="1.75"
      />
    </svg>
  );
}
